const PATH =
  'fe.components.measure.view.cycles.meta_data_category_form.labels_box';

const messages = {
  howMuchTime: {
    none: {
      key: `${PATH}.how_much_time.none`,
      defaultValue: 'none'
    },
    some: {
      key: `${PATH}.how_much_time.some`,
      defaultValue: 'some'
    },
    most: {
      key: `${PATH}.how_much_time.most`,
      defaultValue: 'most'
    }
  },
  howManyChildren: {
    few: {
      key: `${PATH}.how_many_children.few`,
      defaultValue: 'few'
    },
    some: {
      key: `${PATH}.how_many_children.some`,
      defaultValue: 'some'
    },
    many: {
      key: `${PATH}.how_many_children.many`,
      defaultValue: 'many'
    }
  },
  howActive: {
    disengaged: {
      key: `${PATH}.how_active.disengaged`,
      defaultValue: 'disengaged'
    },
    mixed: {
      key: `${PATH}.how_active.mixed`,
      defaultValue: 'mixed'
    },
    active: {
      key: `${PATH}.how_active.active`,
      defaultValue: 'active'
    }
  }
};

export default messages;
